import template from './services.html';

const servicesComponent = {
  restrict: 'E',
  bindings: {},
  template
};

export default servicesComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/services.component.js
 **/